export const CLEAR_WALLET_STATE = "CLEAR_WALLET_STATE";

export const TOGGLE_FETCHING_WALLET_TRANSACTIONS =
  "TOGGLE_FETCHING_WALLET_TRANSACTIONS";
export const SET_WALLET_TRANSACTIONS = "SET_WALLET_TRANSACTIONS";
export const SET_SELECTED_TRANSACTION = "SET_SELECTED_TRANSACTION";
